<template>
  <div style="width: 100%">
    <Breadcrumb></Breadcrumb>

    <div class="common-limit line-height-40">
      <div class="form-body">
        <el-form ref="form" :model="queryParams" label-width="80px">
          <el-row :gutter="24">
            <el-col :span="8">
              <el-form-item label="账号：" prop="fundType">
                <el-input
                  v-model="queryParams.userName"
                  size="small"
                  placeholder="请输入内容"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="姓名：" prop="nickName">
                <el-input
                  v-model="queryParams.nickName"
                  size="small"
                  placeholder="请输入内容"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="手机号：" prop="fundType">
                <el-input
                  v-model="queryParams.phoneNumber"
                  size="small"
                  placeholder="请输入内容"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="8">
              <el-form-item label="角色：" prop="fundType">
                <el-select clearable v-model="queryParams.roleIds" size="small">
                  <el-option
                    v-for="(record, index) in roleOption"
                    :key="index"
                    :label="record.roleName"
                    :value="record.roleId"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="状态：" prop="operNo">
                <el-select size="small" clearable v-model="queryParams.status">
                  <el-option label="正常" value="1"></el-option>
                  <el-option label="停用" value="0"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="创建时间：" prop="time">
                <el-date-picker
                  size="small"
                  v-model="queryParams.time"
                  type="daterange"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerOptions"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="24" style="text-align: right">
              <el-button type="primary" size="small" @click="loadList"
                >搜索</el-button
              >
              <el-button size="small" @click="resetForm">重置</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
    <div class="form-body userList common-limit">
      <div style="overflow: hidden">
        <div class="left">
          <el-button type="primary" size="small" @click="handleAdd"
            >创建成员</el-button
          >
        </div>
        <pagination
          v-show="total > 0"
          :total="total"
          :page.sync="queryParams.pageNum"
          :limit.sync="queryParams.pageSize"
          @pagination="loadList"
        />
      </div>
      <!-- 表格 -->
      <el-table :data="tableData" class="border">
        <el-table-column prop="userName" label="帐号" align="center">
        </el-table-column>
        <el-table-column prop="nickName" label="姓名" align="center">
        </el-table-column>
        <el-table-column
          prop="phoneNumber"
          label="手机号码"
          align="center"
        ></el-table-column>
        <el-table-column prop="" label="角色" align="center">
          <template slot-scope="scope">
            {{ getRoleName(scope.row.roles) }}
          </template>
        </el-table-column>
        <el-table-column prop="" label="关联店铺数" align="center">
          <template slot-scope="scope">
            <span> {{ scope.row.shops.length }}</span>

            <i
              @click="handleUpdate(scope.row)"
              class="el-icon-edit-outline blue"
              style="margin: 0 0 0 8px"
            ></i>
          </template>
        </el-table-column>
        <el-table-column prop="" label="读取账户数" align="center">
          <template slot-scope="scope">
            <span @click="handleSetReceives(scope.row)">
              {{ scope.row.receives.length }}</span
            >

            <i
              @click="handleSetReceives(scope.row)"
              class="el-icon-edit-outline blue"
              style="margin: 0 0 0 8px"
            ></i>
          </template>
        </el-table-column>
        <el-table-column prop="" label="共享账户数" align="center">
          <template slot-scope="scope">
            <span @click="handleSetShares(scope.row)">
              {{ scope.row.shares.length }}</span
            >
            <i
              @click="handleSetShares(scope.row)"
              class="el-icon-edit-outline blue"
              style="margin: 0 0 0 8px"
            ></i>
          </template>
        </el-table-column>

        <el-table-column
          prop="createTime"
          label="创建日期"
          align="center"
          width="158px"
        ></el-table-column>
        <el-table-column
          prop="remark"
          align="center"
          label="备注"
          width="180"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column prop="status" label="状态" align="center">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.userStatus"
              @change="handleStatusChange(scope.row)"
            >
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="230" align="center">
          <template slot-scope="scope">
            <el-button @click="handleUpdate(scope.row)" type="text" size="small"
              >编辑</el-button
            >
            <el-button
              @click="handleResetPwd(scope.row)"
              type="text"
              size="small"
              >重置密码</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="loadList"
      />
    </div>

    <el-dialog
      :close-on-click-modal="false"
      title="读取账号数据"
      :visible.sync="receivesVisible"
      width="600px"
    >
      <el-form
        :model="formShares"
        ref="form"
        label-width="112px"
        :rules="rules"
        class="create-user-form"
      >
        <el-row>
          <el-col :span="24">
            <el-button
              @click="handleShowAccount('设置读取账号')"
              size="small"
              type="primary"
              >设置读取账号</el-button
            >
          </el-col>
        </el-row>
        <el-row v-show="checkList.length > 0">
          <el-table
            @selection-change="handleSelectionChange"
            :data="checkList"
            border
          >
            <el-table-column prop="userName" label="读取帐号" align="center">
            </el-table-column>
            <el-table-column prop="phoneNumber" label="操作页面" align="center">
              <template slot-scope="scope">
                <div>
                  <el-checkbox-group v-model="scope.row.checkList">
                    <el-checkbox label="我的图库"></el-checkbox>
                    <el-checkbox label="我的设计"></el-checkbox>
                    <el-checkbox label="产品模板"></el-checkbox>
                    <el-checkbox label="汇出记录"></el-checkbox>
                  </el-checkbox-group>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              label="操作"
              width="180"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <el-button @click="handleSelectAccount(scope.row)" type="text"
                  >选择所有权限</el-button
                ><br />
                <el-button @click="handleUnSelectAccount(scope.row)" type="text"
                  >移除所有权限</el-button
                ><br />
                <el-button @click="handleDeleteAccount(scope.row)" type="text"
                  >移除账号</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-row>
      </el-form>
      <!-- 按钮 -->
      <div slot="footer" class="dialog-footer">
        <el-button @click="receivesVisible = false" size="small"
          >取 消</el-button
        >
        <el-button type="primary" @click="handleAddReceive" size="small"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      title="共享账号数据"
      :visible.sync="sharesVisible"
      width="600px"
    >
      <el-form
        :model="formShares"
        ref="form"
        label-width="112px"
        :rules="rules"
        class="create-user-form"
      >
        <el-row>
          <el-col :span="24">
            <el-button
              @click="handleShowAccount('设置共享账号')"
              size="small"
              type="primary"
              >设置共享账号</el-button
            >
          </el-col>
        </el-row>
        <el-row v-show="checkList.length > 0">
          <el-table
            @selection-change="handleSelectionChange"
            :data="checkList"
            border
          >
            <el-table-column prop="userName" label="读取帐号" align="center">
            </el-table-column>
            <el-table-column prop="phoneNumber" label="操作页面" align="center">
              <template slot-scope="scope">
                <div>
                  <el-checkbox-group v-model="scope.row.checkList">
                    <el-checkbox label="我的图库"></el-checkbox>
                    <el-checkbox label="我的设计"></el-checkbox>
                    <el-checkbox label="产品模板"></el-checkbox>
                    <el-checkbox label="汇出记录"></el-checkbox>
                  </el-checkbox-group>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              label="操作"
              width="180"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <el-button @click="handleSelectAccount(scope.row)" type="text"
                  >选择所有权限</el-button
                ><br />
                <el-button @click="handleUnSelectAccount(scope.row)" type="text"
                  >移除所有权限</el-button
                ><br />
                <el-button @click="handleDeleteAccount(scope.row)" type="text"
                  >删除账号</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-row>
      </el-form>
      <!-- 按钮 -->
      <div slot="footer" class="dialog-footer">
        <el-button @click="sharesVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="handleAddShare" size="small"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      :title="shareTitle"
      :visible.sync="childAccountVisible"
      width="600px"
      @close="closeDialog1"
    >
      <div style="margin: 8px 0">
        <el-input
          v-model="filterText"
          placeholder="请输入账号、手机号或者姓名"
        ></el-input>
      </div>
      <div style="height: 500px; overflow-y: auto">
        <el-table
          @selection-change="handleSelectionChangeAccount"
          :data="accountListShow"
          class="border"
        >
          <el-table-column
            type="selection"
            width="55"
            align="center"
          ></el-table-column>
          <el-table-column prop="userName" label="帐号" align="center">
          </el-table-column>
          <el-table-column
            prop="phoneNumber"
            label="手机号码"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="nickName"
            label="姓名"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="remark"
            align="center"
            label="角色"
            width="180"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ getRoleName(scope.row.roles) }}
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 按钮 -->
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelAccount" size="small">取 消</el-button>
        <el-button type="primary" @click="handleCheckAccount" size="small"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      :title="title"
      :visible.sync="dialogFormVisible"
      width="800px"
      @close="closeDialog"
    >
      <el-form
        :model="form"
        ref="form"
        label-width="112px"
        :rules="rules"
        class="create-user-form"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="账号："
              prop="userName"
              v-if="form.userId == undefined"
            >
              <el-input size="small" v-model.trim="form.userName"></el-input>
            </el-form-item>
            <el-form-item label="姓名：" prop="nickName">
              <el-input size="small" v-model="form.nickName"></el-input>
            </el-form-item>
            <el-form-item label="角色：" prop="roleIds">
              <el-select
                clearable
                style="width: 100%"
                multiple
                size="small"
                v-model="form.roleIds"
                placeholder="请选择"
              >
                <el-option
                  :key="item.roleName"
                  v-for="item in roleOption"
                  :value="item.roleId"
                  :label="item.roleName"
                  >{{ item.roleName }}</el-option
                >
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="密码："
              prop="password"
              v-if="form.userId == undefined"
            >
              <el-input
                type="password"
                size="small"
                v-model.trim="form.password"
              ></el-input>
            </el-form-item>
            <el-form-item label="手机号：" prop="phoneNumber">
              <el-input size="small" v-model="form.phoneNumber"></el-input>
            </el-form-item>
            <el-form-item v-if="false" label="状态：">
              <el-radio-group v-model="form.status">
                <el-radio
                  v-for="dict in statusOptions"
                  :key="dict.dictValue"
                  :label="dict.dictValue"
                  >{{ dict.dictLabel }}</el-radio
                >
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="店铺权限：">
              <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="亚马逊店铺" name="amazon"></el-tab-pane>
                <el-tab-pane label="lazada" name="lazada"></el-tab-pane>
                <el-tab-pane label="shopee" name="shopee"></el-tab-pane>
                <el-tab-pane label="shopify" name="shopify"></el-tab-pane>
                <el-tab-pane label="shopline" name="shopline"></el-tab-pane>
                <el-tab-pane label="店匠" name="店匠"></el-tab-pane>
                <el-tab-pane label="自助店铺" name="other"></el-tab-pane>
              </el-tabs>
              <el-checkbox-group v-model="form.shopIds">
                <el-checkbox
                  v-show="
                    (activeName == 'amazon' && item.platNo == '04') ||
                      (activeName == 'shopee' && item.platNo == '05') ||
                      (activeName == 'lazada' && item.platNo == '03') ||
                      (activeName == 'shopify' && item.platNo == '06') ||
                      (activeName == 'shopline' && item.platNo == '07') ||
                      (activeName == '店匠' && item.platNo == '08') ||
                      (activeName == 'other' && item.platNo == '09')
                  "
                  v-for="item in shopList"
                  style="display: block; float: left; width: 260px"
                  :key="item.shopId"
                  :label="item.shopId"
                  :value="item.shopId"
                  >{{ item.shopName }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注：">
              <el-input
                size="small"
                v-model="form.remark"
                placeholder="请输入内容"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="!form.userId">
          <el-col :span="24">
            <el-form-item label="读取数据账号：">
              <el-button
                @click="handleShowAccount('设置读取账号')"
                size="small"
                type="primary"
                >设置读取账号</el-button
              >
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="!form.userId">
          <el-table
            @selection-change="handleSelectionChange"
            :data="checkList"
            border
          >
            <el-table-column prop="userName" label="读取帐号" align="center">
            </el-table-column>
            <el-table-column prop="phoneNumber" label="操作页面" align="center">
              <template slot-scope="scope">
                <div>
                  <el-checkbox-group v-model="scope.row.checkList">
                    <el-checkbox label="我的图库"></el-checkbox>
                    <el-checkbox label="我的设计"></el-checkbox>
                    <el-checkbox label="产品模板"></el-checkbox>
                    <el-checkbox label="汇出记录"></el-checkbox>
                  </el-checkbox-group>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              label="操作"
              width="180"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <el-button @click="handleSelectAccount(scope.row)" type="text"
                  >选择所有权限</el-button
                ><br />
                <el-button @click="handleUnSelectAccount(scope.row)" type="text"
                  >移除读取账号</el-button
                ><br />
                <el-button @click="handleDeleteAccount(scope.row)" type="text"
                  >删除账号</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-row>
      </el-form>
      <!-- 按钮 -->
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel" size="small">取 消</el-button>
        <el-button type="primary" @click="submitForm" size="small"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Breadcrumb from "@/components/common/Breadcrumb"
import { allRole } from "@/api/system/role"
import { getShopList } from "@/api/shop/shop"
import {
  addUser,
  delUser,
  listUser,
  updateUser,
  changeUserStatus,
  resetUserPwd,
  addMember,
} from "@/api/system/user"
import { listRole } from "@/api/system/role"
import { listSubAccount, addReceive, addShare } from "@/api/system/user"

export default {
  name: "userList",
  components: { Breadcrumb },
  data() {
    return {
      // 遮罩层
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      total: 0,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        userName: "",
        nickName: "",
        phoneNumber: "",
        status: "",
        roleIds: "",
        beginTime: undefined,
        endTime: undefined,
        time: [],
      },
      // 表格
      tableData: [],
      // 表单
      dialogFormVisible: false,
      receivesVisible: false,
      sharesVisible: false,
      title: "",
      form: {},
      formShares: {
        userName: "",
        shares: [],
      },
      statusOptions: [],
      rules: {
        userName: [
          { required: true, message: "账号不能为空", trigger: "blur" },
          {
            min: 1,
            max: 20,
            message: "账号最大20个字符",
            trigger: "blur",
          },
        ],
        nickName: [
          { required: true, message: "姓名不能为空", trigger: "blur" },
          {
            min: 1,
            max: 20,
            message: "账号最大20个字符",
            trigger: "blur",
          },
        ],
        password: [
          { required: true, message: "密码不能为空", trigger: "blur" },
          {
            min: 6,
            max: 20,
            message: "密码长度在6到20个字符",
            trigger: "blur",
          },
        ],
        roleIds: [
          { required: true, message: "角色不能为空", trigger: "change" },
        ],
        phoneNumber: [
          { required: true, message: "手机号不能为空", trigger: "change" },
        ],
      },
      filterText: "",
      shop: [],
      roleOption: [],
      shopList: [],
      accountChecks: [],
      childAccountVisible: false,
      accountList: [],
      accountListShow: [],
      checkList: [],
      shareTitle: "设置读取账号",
      activeName: "amazon",
    }
  },
  watch: {
    async childAccountVisible() {
      if (this.childAccountVisible) {
        let result = await listSubAccount()
        let array = []
        result.rows.map((record) => {
          record.checkList = []
          if (record.userName != this.formShares.userName) {
            array.push(record)
          }
        })

        this.accountList = this.accountListShow = array
      }
    },
    filterText: {
      handler() {
        this.accountListShow = this.accountList.filter((record) => {
          if (
            (record.userName &&
              record.userName.indexOf(this.filterText) > -1) ||
            (record.phoneNumber &&
              record.phoneNumber.indexOf(this.filterText) > -1) ||
            (record.nickName && record.nickName.indexOf(this.filterText)) > -1
          ) {
            return true
          }
          return false
        })
      },
      immediate: true,
    },
  },

  created() {
    this.getAllRole()
    this.loadList()
    this.getShops()
    this.getDicts("sys_normal_disable").then((response) => {
      this.statusOptions = response.data
    })
  },
  methods: {
    handleShowAccount(title) {
      this.shareTitle = title
      this.accountChecks = []
      this.childAccountVisible = true
    },
    //记载成员列表数据
    getShops() {
      getShopList().then((res) => {
        this.shopList = res.rows
      })
    },
    getRoleName(roles) {
      let array = []
      roles.map((role) => {
        array.push(role.roleName)
      })
      return array.join(",")
    },
    getShopName(shops) {
      let array = []
      shops.map((shop) => {
        array.push(shop.shopName)
      })
      return array.join(",")
    },
    loadList() {
      this.startLoading()
      if (this.queryParams.time) {
        this.queryParams.beginTime = this.queryParams.time[0]
        this.queryParams.endTime = this.queryParams.time[1]
      } else {
        this.queryParams.beginTime = undefined
        this.queryParams.endTime = undefined
      }
      let params = Object.assign({}, this.queryParams)
      delete params["time"]

      listUser(params).then((res) => {
        this.total = res.total
        res.rows.map((record) => {
          record.userStatus = record.status == "1"
        })
        this.tableData = res.rows
        this.endLoading()
      })
    },
    getAllRole() {
      allRole().then((res) => {
        this.roleOption = res.data
      })
    },
    handleAdd() {
      this.reset()
      this.title = "创建成员"
      this.dialogFormVisible = true
      this.getShops()
    },
    handleSelectAccount(record) {
      record.checkList = ["我的图库", "我的设计", "产品模板", "汇出记录"]
    },
    handleDeleteAccount(record) {
      for (var i = 0; i < this.checkList.length; i++) {
        if (record.userName == this.checkList[i].userName) {
          this.checkList.splice(i, 1)
          break
        }
      }
    },
    handleUnSelectAccount(record) {
      record.checkList = []
    },
    handleUpdate(row) {
      this.reset()
      const userIds = row.userId || this.ids
      let form = JSON.parse(JSON.stringify(row))
      this.title = "编辑成员"
      this.dialogFormVisible = true
      this.getShops()
      let shopIds = []
      let roleIds = []
      row.roles.map((record) => {
        roleIds.push(record.roleId)
      })
      row.shops.map((record) => {
        shopIds.push(record.shopId)
      })
      form.shopIds = shopIds
      form.roleIds = roleIds
      this.form = form
    },
    handleSetReceives(row) {
      let checkList = []
      this.formShares.userName = row.userName
      row.receives.map((record) => {
        let menus = record.menuId ? record.menuId.split(",") : []
        checkList.push({ userName: record.shareNo, checkList: menus })
      })
      this.checkList = checkList
      this.receivesVisible = true
    },
    handleSetShares(row) {
      let checkList = []
      this.formShares.userName = row.userName
      row.shares.map((record) => {
        let menus = record.menuId ? record.menuId.split(",") : []
        checkList.push({ userName: record.receiveNo, checkList: menus })
      })
      this.checkList = checkList
      this.sharesVisible = true
    },

    async handleAddReceive() {
      let form = this.formShares
      let shares = []
      // if (this.checkList.length === 0) {
      //   this.msgError("请选择账号")
      //   return
      // }
      this.checkList.map((record) => {
        shares.push({
          shareNo: record.userName,
          menuId: record.checkList.join(","),
        })
      })
      delete form["shares"]
      form.receives = shares
      await addReceive(form)
      this.receivesVisible = false
      this.loadList()
    },

    async handleAddShare() {
      let form = this.formShares
      let shares = []
      // if (this.checkList.length === 0) {
      //   this.msgError("请选择账号")
      //   return
      // }
      this.checkList.map((record) => {
        shares.push({
          receiveNo: record.userName,
          menuId: record.checkList.join(","),
        })
      })
      delete form["receives"]
      form.shares = shares
      await addShare(form)
      this.sharesVisible = false
      this.loadList()
    },
    handleDelete(row) {
      const userIds = row.userId || this.ids
      this.$confirm("是否确认删除选中的账号吗?", "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(function() {
          return delUser(userIds)
        })
        .then(() => {
          this.loadList()
          this.msgSuccess("删除成功")
        })
        .catch(function() {})
    },
    closeDialog() {
      this.reset()
    },
    closeDialog1() {
      this.filterText = ""
    },
    //提交修改或新增表单
    submitForm() {
      this.$refs["form"].validate((valid, msgArr) => {
        let form = this._.clone(this.form)
        //开始构造share

        if (valid) {
          if (form.userId != undefined) {
            delete form["shares"]
            delete form["receives"]
            updateUser(form).then((response) => {
              if (response.code === 200) {
                this.msgSuccess("修改成功")
                this.dialogFormVisible = false
                this.loadList()
              }
            })
          } else {
            let receives = []
            this.checkList.map((record) => {
              receives.push({
                shareNo: record.userName,
                menuId: record.checkList.join(","),
              })
            })
            form.receives = receives
            addMember(form).then((res) => {
              if (res.code == 200) {
                this.msgSuccess("创建成功")
                this.dialogFormVisible = false
                this.loadList()
              }
            })
          }
        } else {
          let arr = []
          for (let item in msgArr) {
            msgArr[item].forEach((obj) => {
              if (arr.indexOf(obj.message) < 0) {
                arr.push(obj.message)
              }
            })
          }
          this.$message.error({
            dangerouslyUseHTMLString: true,
            showClose: true,
            message: "<span>" + arr.join("，") + "</span>",
          })
        }
      })
    },
    //取消
    cancel() {
      this.dialogFormVisible = false
      this.reset()
    },
    cancelAccount() {
      this.childAccountVisible = false
      this.filterText = ""
    },
    // 表单重置
    reset() {
      this.form = {
        userId: undefined,
        userName: undefined,
        nickName: undefined,
        password: undefined,
        phoneNumber: undefined,
        status: "0",
        remark: undefined,
        roleIds: [],
        shopIds: [],
        time: [],
      }
      this.resetForm("form")
    },
    resetForm() {
      this.queryParams = Object.assign(this.queryParams, {
        userName: "",
        nickName: "",
        phoneNumber: "",
        status: "",
        roleIds: "",
        beginTime: undefined,
        endTime: undefined,
        time: [],
      })
      this.$refs["form"].resetFields()
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.checkList = selection
    },
    handleSelectionChangeAccount(selection) {
      this.accountChecks = selection
    },
    handleCheckAccount() {
      if (this.accountChecks.length == 0) {
        this.msgError("请选择账号")
        return
      }
      for (let record of this.accountChecks) {
        let find = false
        for (let account of this.checkList) {
          if (account.userName == record.userName) {
            find = true
            break
          }
        }
        if (!find) {
          this.checkList.push({
            userName: record.userName,
            checkList: [],
          })
        }
      }
      this.childAccountVisible = false
    },
    // 用户状态修改
    handleStatusChange(row) {
      let text = row.userStatus ? "启用" : "停用"
      this.$confirm(
        '确认要"' + text + '""' + row.userName + '"用户吗?',
        "警告",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(function() {
          return changeUserStatus(row.userId, row.userStatus ? "1" : "0")
        })
        .then(() => {
          this.msgSuccess(text + "成功")
        })
        .catch(function() {
          row.userStatus = !row.userStatus
        })
    },
    /** 重置密码按钮操作 */
    handleResetPwd(row) {
      this.$prompt('请输入"' + row.userName + '"的新密码', "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /^\S{6,}$/,
        inputErrorMessage: "密码至少需要6位",
      })
        .then(({ value }) => {
          resetUserPwd(row.userId, value).then((response) => {
            if (response.code === 200) {
              this.msgSuccess("修改成功，新密码是：" + value)
            }
          })
        })
        .catch(() => {})
    },
    handleCheckAllChange(val) {},
    handleCheckedCitiesChange(value) {},
  },
}
</script>
<style scoped>
.create-user-form {
  padding: 10px 30px 0 0;
  height: 60vh;
  overflow: auto;
}
.create-user-form .el-form-item {
  margin-bottom: 15px !important;
}

.userList .el-table--fit {
  border-right: 0 !important;
  border-left: 0 !important;
  border-bottom: 0 !important;
  margin: 3px 0;
}
.create-user-form ::v-deep .el-checkbox:last-of-type {
  margin-right: 30px;
}
.blue {
  color: #409eff;
  cursor: pointer;
}
</style>

<style lang="scss">
.tablescope {
  .el-switch__label--left {
    position: relative;
    left: 66px;
    color: #fff;
    z-index: -1111;
    white-space: nowrap;
  }
  /*.el-switch__core{*/
  /*width: 50px !important;*/
  /*}*/
  .el-switch__label--right {
    position: relative;
    right: 66px;
    color: #fff;
    z-index: -1111;
    white-space: nowrap;
  }
  .el-switch__label--right.is-active {
    z-index: 1111;
    color: #fff;
  }
  .el-switch__label--left.is-active {
    z-index: 1111;
    color: #595a5a !important;
  }
}
</style>
